import Cookies from 'js-cookie'

const Token = 'token'
export function getToken(token = Token) {
  // console.log('token', token);
  return Cookies.get(token)
}

export function setToken(token) {
  const oneHours = 1 / 24 * 1
  // Cookies.set(Token, token, { expires: oneHours })
  // console.log('tokenset', token); // 手机号
  Cookies.set(Token, token)
}

export function removeToken() {
  Cookies.remove(Token)
}

export function setUserInfo(info) {
  Cookies.set('userInfo', info)
}

export function getUserInfo() {
  let info = Cookies.get('userInfo')
  if (info) {
    return JSON.parse(info)
  }
  return info
}
